import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  Inject,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  takeUntil,
} from 'rxjs/operators';
import { Labels, LocationLabels, SdfCardLabels } from '../../../app.models';
import { LocationFinderService } from '../../../services/location-finder.service';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
import { BaseComponent } from '../../../shared/base.component';
import { Store } from '@ngrx/store';
import { selectQueryParams } from 'src/app/store/query-params';
import { isSdfCardFlow } from '../../../config/app-config';
import { Observable, Subscription } from 'rxjs';
import { Who } from 'src/app/models/location.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertLocationComponent } from '../../../shared/dialog/alert-location/alert-location.component';
import { getFxrateSummary } from 'src/app/store/fee-quote/fee-quote.selectors';
import { SetLocFiltersAction } from 'src/app/store/locations/location.actions';

@Component({
    selector: 'app-location-search',
    templateUrl: './location-search.component.html',
    styleUrls: ['./location-search.component.scss'],
    standalone: false
})
export class LocationSearchComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  searchKeyword!: string;
  searchKeywordControl = new FormControl();
  isSdfCardFlow = false;
  sdfCardLabels: SdfCardLabels;
  isAlertDialogClosed: boolean = true;
  alertRef: MatDialogRef<AlertLocationComponent>;

  // sortOptions: string[] = ['Popular', 'Nearby', 'Open Now'];
  // selectedOptions: string[] = ['Popular'];
  sortOptions: string[] = [];
  selectedOptions: string[] = [];
  additonalPayloadFxRate: any;

  private subscriptions: Subscription = new Subscription();

  public ismobile$: Observable<boolean>;
  public isMobileSize: boolean;
  public showAutocompleteList: boolean = false;
  public arrayAutocompleteList: {
    continued: string;
    boldSection: string;
    description: string;
  }[] = []; //TODO: create object on modal
  @Output() upOnClose: EventEmitter<any> = new EventEmitter();
  @Output() basicSearchEvent: EventEmitter<void> = new EventEmitter();
  @Input() flow: string;
  private endpoint: string;
  public _google: any;

  @Input() public set google(map: any) {
    this._google = map;
    if (this._google) {
      setTimeout(() => {
        this.initAutoComplete();
      }, 100);
    }
  }

  public searchError: boolean = false;
  public locationLabels: any;
  // public isViewMoreSearch: boolean = false;

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.sdfCardLabels = labels.stellar.sdfcard;
    this.locationLabels = labels.stellar.location;
    this.sortOptions = [this.sdfCardLabels.locationMaps.popular, this.sdfCardLabels.locationMaps.nearby, this.sdfCardLabels.locationMaps.openNow]
    this.selectedOptions = [this.sdfCardLabels?.locationMaps?.popular]
  }
  public get labels() {
    return this._labels;
  }

  public get google() {
    return this._google;
  }

  public autocomplete: any;
  public autocompleteService: any;

  @ViewChild('refUlPredictions', { static: true })
  refUlPredictions!: ElementRef;
  @ViewChild('refSearchKeyword', { static: true })
  refSearchKeyword!: ElementRef;

  constructor(
    public locationFinderService: LocationFinderService,
    private store: Store<any>,
    @Inject(DOCUMENT) private document: any,
    public mobileBreakPointsService: MobileBreakPointsService,
    public alertDialog: MatDialog
  ) {
    super();
    this.isSdfCardFlow = isSdfCardFlow;
    this.ismobile$ = this.mobileBreakPointsService.mobileBreakPoints$;
    this.ismobile$.subscribe((isMobile: any) => { // Todo: Tim: Fix type
      this.isMobileSize = isMobile;
    });
  }

  public ngOnInit() {
    this.store.dispatch(
      SetLocFiltersAction({ searchFilters: this.selectedOptions })
    );
    this.locationFinderService.flow = this.flow;
    this.locationFinderService.labels =  this.sdfCardLabels
    this.locationFinderService.filters = this.selectedOptions
    /* get endpoint version from queryParams */
    // Todo: this can be removed when all wallets are using v3/anchor platform
    this.store.select(selectQueryParams).subscribe((queryParamsData) => {
      this.endpoint = queryParamsData.endpoint || 'v2';
    });
    this.onChangeSearch(); //to init the list of autocomplete or predictions
    /* update result from service */
    this.locationFinderService.searchCompleted
      .pipe(takeUntil(this.destroy$))
      .subscribe((obj) => {
        this.updateSearchInput();
        const searchResults = this.locationFinderService.searchResults;
        if (searchResults?.error && this.isAlertDialogClosed) {
          this.searchError = searchResults.error;
          this.showAutocompleteList = true;
        }
      });

    /* Load previous search result if available */
    if (!!this.locationFinderService.searchResults) {
      this.updateSearchInput();
    }

    this.store.select(getFxrateSummary).subscribe((fxRate) => {
      this.additonalPayloadFxRate = fxRate;
    });
  }

  toggleSelection(option: string): void {
    const index = this.selectedOptions.indexOf(option)
    let copyOptions = [...this.selectedOptions]

    if(index >=0) {
      copyOptions.splice(index, 1)
    } else {
      copyOptions.push(option)
      const popularLabel = this.sdfCardLabels.locationMaps.popular;
      const nearbyLabel = this.sdfCardLabels.locationMaps.nearby
      if( option === popularLabel && copyOptions.includes(nearbyLabel)) {
        copyOptions = copyOptions.filter(opt => opt !== nearbyLabel)
      } else if( option === nearbyLabel && copyOptions.includes(popularLabel)) {
        copyOptions = copyOptions.filter(opt => opt !== popularLabel)
      }
    }
    this.selectedOptions = copyOptions
    this.locationFinderService.filters = this.selectedOptions

    setTimeout(() => {
      this.store.dispatch(SetLocFiltersAction({searchFilters: this.selectedOptions}))
    }, 0)
  }

  isSelected(option: string): boolean {
    return this.selectedOptions.indexOf(option) >= 0;
  }

  private initAutoComplete(): void {
    const inputElement = this.document.getElementById('searchKeyword');

    // const options = {
    //   radius: 4000, // in meters
    //   types: ['address'],
    //   componentRestrictions: {
    //     country: this.locationFinderService.selectedCountry.iso2Code
    //   }
    // };
    if (inputElement) {
      this.autocompleteService =
        new this.google.maps.places.AutocompleteService();
      // this.autocomplete = new this.google.maps.places.Autocomplete(
      //   inputElement,
      //   options
      // );

      // this.autocomplete.addListener('place_changed', () => {
      //   this.fillInAddress();
      // });
    }

    // setTimeout(() => {
    //   if(this.document.getElementById("autocompleteSuggestions")) {
    //     this.document.getElementById("autocompleteSuggestions").appendChild(this.document.querySelector(".pac-container"));
    //   }
    // }, 300);

    this.google.maps.event.addDomListener(
      inputElement,
      'keydown',
      (event: { keyCode: number; preventDefault: () => void }) => {
        if (event.keyCode === 13) {
          event.preventDefault();
        }
      }
    );
  }

  private fillInAddress = () => {
    const placeDetail = this.autocomplete.getPlace();
    if (placeDetail.formatted_address) {
      this.searchKeywordControl.patchValue(placeDetail.formatted_address);
    }
    this.searchLocation();
  };

  private updateSearchInput(): void {
    this.searchKeywordControl.setValue(
      this.locationFinderService.searchQuery.address
    );
    this.refSearchKeyword.nativeElement.blur(); //to handle better hide or show the Map
    //this.focusSearchInput();
  }

  // ** ----- action events for ul element, searchINput and his other buttons related ----
  public onFocusSearch(event: Event) {
    this.searchError = false;
    (event.target as HTMLInputElement).select();
    this.onChangeSearch();
  } // on click the input search activate select all the text

  public handleClickRemoveInputTextSearchLoc(
    searchKeywordControl: FormControl
  ): void {
        this.searchKeywordControl.reset()
        this.locationFinderService.resetSearchQuery()
        this.arrayAutocompleteList = [];
        this.locationFinderService.hide(Who.map, false);
        this.showAutocompleteList = false;
        this.locationFinderService.resetSearchResults()
  }

  public handleFormatString(value: string)  : string {
    return value.split(" ").map((word, index) => {
      if(index === 0) {
        return word.charAt(0).toLocaleUpperCase() + word.slice(1).toLocaleLowerCase()
      } {
        return word.toLocaleLowerCase()
      }
    }).join(" ")
  }

  public handleBlurSearchLocation(): void {
    //case to include blur with empty text value Search
    if (!this.searchKeywordControl.getRawValue()) {
      this.locationFinderService.hide(Who.map, false);
    }
  }
  public onChangeSearch() {
    //when text INput is changing the list UL is launching options
    const valueInputChanged = this.searchKeywordControl.getRawValue();
    if (valueInputChanged) {
      //autocompleteService Never works when is not Mobile
      this.showAutocompleteList = true;
      this.locationFinderService.hide(Who.listResult, true);
      if (this.isMobileSize) {
        this.locationFinderService.hide(Who.map, true);
      }

      this.autocompleteService.getPlacePredictions(
        { input: valueInputChanged },
        (predictions: any) => {
          if (predictions !== null) {
            this.arrayAutocompleteList = predictions.map(
              (prediction: { description: string }) => {
                const indexComma = prediction.description.indexOf(',');
                let boldSection = '';
                if (indexComma !== -1) {
                  boldSection =
                    prediction.description.substring(0, indexComma) + ', ';
                }

                return {
                  boldSection,
                  continued: prediction.description.substring(indexComma + 1),
                  description: prediction.description,
                };
              }
            );
          } else {
            this.arrayAutocompleteList = []; // when there are no Results or 0 results
          }
        }
      );
    } else {
      this.arrayAutocompleteList = [];
      this.locationFinderService.hide(Who.map, false);
      this.locationFinderService.hide(Who.listResult, false);
    }
  }
  public onclickLiAddressPredicted(address: string) {
    this.searchKeywordControl.setValue(address.trim());
    setTimeout(() => this.handleBasicSearch(), 500);
  }

  public handleBasicSearch(): void {
    this.locationFinderService.updateViewMoreSearch(false);
    this.basicSearchEvent.emit();
    this.searchLocation()
  }

  public handleViewMoreSearch(): void {
    this.locationFinderService.updateViewMoreSearch(true);
    this.searchLocation()
  }

  public searchLocation(): void {
    //Main execute the search location for the Map
    this.refSearchKeyword.nativeElement.blur();
    this.locationFinderService.hide(Who.map, false);
    this.locationFinderService.hide(Who.listResult, false);
    this.showAutocompleteList = false;
    if (this.searchKeywordControl.value) {
      this.locationFinderService.updateSearchQuery({
        address: this.searchKeywordControl.value,
      });
    }

    this.locationFinderService
      .searchLocationApi(this.flow, this.endpoint, this.additonalPayloadFxRate)
      .subscribe((data) => {
        const searchResults = this.locationFinderService.searchResults;
        if (
          searchResults?.error &&
          this.isAlertDialogClosed &&
          this.isMobileSize
        ) {
          this.openAlertDialog();
        }
        this.locationFinderService.searchCompleted.next(true);
      });
    this.locationFinderService.updateViewMoreSearch(false);
  }
  // ** ------------

  placeHolderSearch() {
    //TODO: remove function  after request new CMS tag
    // [placeholder]="labels.searchHelpText"
    return this.sdfCardLabels.locationMaps.searchCityZipCode;
  }

  openAlertDialog(): void {
    if (this.isAlertDialogClosed) {
      this.alertRef = this.alertDialog.open(AlertLocationComponent, {
        data: {
          labels: this.labels,
          isAlertOpen: true,
          closeAlert: () => this.closeAlert(),
        },
        panelClass: 'dialog-no-animations',
      });
      this.isAlertDialogClosed = false;
    }
  }

  Onclose() {
    this.upOnClose.emit()
  }

  closeAlert() {
    this.alertRef.close();
    this.isAlertDialogClosed = true;
  }
}
